export const dataTableLaraThemeConfig = {
  colorScheme: {
    light: {
      sortIconSize: "16px",
      headerCell: {
        background: "{gray.50}",
        color: "{gray.500}",
        padding: "var(--spacing-12) var(--spacing-16)",
        borderColor: "{gray.200}",
      },
      bodyCell: {
        padding: "var(--spacing-16)",
      },
    },
  },
  css: () => `
    .p-sortable-column-icon {
      display: flex;
    }
  `,
};
